import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateShopWorkflowLogistician(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const mutation = $api.useMutation("patch", "/shops-workflowlogistician/{shopId}/workflowlogistician");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (activated: boolean) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: {
          activated,
        },
      });
    },
  });
}
